export default __webpack_public_path__ + "static/media/emptychat2.0e203174.svg";